import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CashBill = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 6H5C3.346 6 2 7.346 2 9V23C2 24.654 3.346 26 5 26H27C28.654 26 30 24.654 30 23V9C30 7.346 28.654 6 27 6ZM28 9V11.899C26.044 11.5 24.499 9.956 24.101 8H27C27.551 8 28 8.449 28 9ZM5 8H7.899C7.5 9.956 5.956 11.501 4 11.899V9C4 8.449 4.449 8 5 8ZM4 23V20.101C5.956 20.5 7.501 22.044 7.899 24H5C4.449 24 4 23.551 4 23ZM9.929 24C9.489 20.939 7.061 18.511 4 18.071V13.929C7.061 13.489 9.489 11.061 9.929 8H22.071C22.511 11.061 24.939 13.489 28 13.929V18.071C24.939 18.511 22.511 20.939 22.071 24H9.928H9.929ZM27 24H24.101C24.5 22.044 26.044 20.499 28 20.101V23C28 23.551 27.551 24 27 24Z" />
		<path d="M16 10C13.757 10 12 12.636 12 16C12 19.364 13.757 22 16 22C18.243 22 20 19.364 20 16C20 12.636 18.243 10 16 10ZM16 20C15.056 20 14 18.289 14 16C14 13.711 15.056 12 16 12C16.944 12 18 13.711 18 16C18 18.289 16.944 20 16 20Z" />
	</svg>
);

export default CashBill;
